export default "__VITE_ASSET__CKls5N3W__"